module.exports = __webpack_public_path__ + "img/level_three.8a695fd2.png";